/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { WhichPageEnum } from './WhichPageEnum';
import { WhichPageEnumFromJSON, WhichPageEnumFromJSONTyped, WhichPageEnumToJSON } from './WhichPageEnum';

/**
 * Serializer for mention notification request
 * @export
 * @interface MentionNotification
 */
export interface MentionNotification {
  /**
   * Required. 150 characters or fewer. Letters, digits and @/./+/-/_ only.
   * @type {string}
   * @memberof MentionNotification
   */
  user: string;
  /**
   *
   * @type {string}
   * @memberof MentionNotification
   */
  email?: string;
  /**
   *
   * @type {number}
   * @memberof MentionNotification
   */
  useCase: number;
  /**
   *
   * @type {WhichPageEnum}
   * @memberof MentionNotification
   */
  whichPage: WhichPageEnum;
}

/**
 * Check if a given object implements the MentionNotification interface.
 */
export function instanceOfMentionNotification(value: object): value is MentionNotification {
  if (!('user' in value) || value['user'] === undefined) return false;
  if (!('useCase' in value) || value['useCase'] === undefined) return false;
  if (!('whichPage' in value) || value['whichPage'] === undefined) return false;
  return true;
}

export function MentionNotificationFromJSON(json: any): MentionNotification {
  return MentionNotificationFromJSONTyped(json, false);
}

export function MentionNotificationFromJSONTyped(json: any, ignoreDiscriminator: boolean): MentionNotification {
  if (json == null) {
    return json;
  }
  return {
    user: json['user'],
    email: json['email'] == null ? undefined : json['email'],
    useCase: json['use_case'],
    whichPage: WhichPageEnumFromJSON(json['which_page']),
  };
}

export function MentionNotificationToJSON(value?: MentionNotification | null): any {
  if (value == null) {
    return value;
  }
  return {
    user: value['user'],
    email: value['email'],
    use_case: value['useCase'],
    which_page: WhichPageEnumToJSON(value['whichPage']),
  };
}
